import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetVendorRateList({ commit}, list) {
    return new Promise((resolve,reject) => {
      axios({
        url: "/vendor_rate/" + list.routingId +"/list",
        params: {
          mobile_network_uuid: list.mobile_network_uuid ? list.mobile_network_uuid : ''
        },
        method: "GET"
      })
      .then(res => {
        resolve(res.data.payload)
      })
      .catch(err => {
        reject(err)
      })
    })
  },
  PostVendorRate({ commit }, vendor) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/vendor_rate/" + vendor.routingId + '/' + vendor.vendorId,
        data: vendor.vendor,
        method: "POST"
      })
      .then(res => {
        console.log("res--->",res)
        resolve(res.data.payload ? res.data.payload  : res.data);
      })
      .catch(err => {
        reject(err);
      });
    });
  },
};

// mutations
const mutations = {};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
